import React from 'react';
import { VStack, Spinner, Text, Center } from '@chakra-ui/react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
  size = 'lg',
}) => {
  return (
    <Center p={8}>
      <VStack spacing={4}>
        <Spinner size={size} color="blue.500" thickness="3px" />
        <Text color="gray.600" fontSize="sm">
          {message}
        </Text>
      </VStack>
    </Center>
  );
};
